"use strict";
// Bootstrap pattern for Module Federation
// This allows shared dependencies to be loaded before the app initializes
import('./bootstrap');
